import { render, staticRenderFns } from "./DadosLead.vue?vue&type=template&id=5c384e3c"
import script from "./DadosLead.vue?vue&type=script&lang=ts"
export * from "./DadosLead.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports